import React from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { Flex } from "@chakra-ui/layout";
import { Icon } from "@chakra-ui/react";

const buttonBgActive = "#fff";
const buttonTextColorActive = "#000";

export const NavItem: React.FC<any> = ({
  closeFn,
  linkTo,
  icon,
  pathname,
  children,
  ...rest
}) => {
  var location = useLocation()
    .pathname.substring(1)
    .toLocaleLowerCase()
    .split("/")
    .pop();

  return (
    <Link to={linkTo} onClick={closeFn}>
      <Flex
        bg={location === pathname ? buttonBgActive : ""}
        color={location === pathname ? buttonTextColorActive : ""}
        align="center"
        p="4"
        mx="4"
        my="2"
        borderRadius={"25px"}
        role="group"
        cursor="pointer"
        _hover={{
          bg: "#7C41FF",
          color: "#fff",
          my: "2",
        }}
        {...rest}
      >
        {icon && <Icon mr="4" fontSize="16" _groupHover={{}} as={icon} />}
        {children}
      </Flex>
    </Link>
  );
};
